<template>
  <div class="card">
    <div class="card-body p-0">
      <cardHead
        :title="'Confirmed Documents'"
        :key="isSelectCount"
        :buttons="[
          {
            title: 'Scan To Queue',
            icon: 'fas fa-sync-alt',
            emit: 'scanToQueue',
            class:
              'btn-primary ' +
              (data != null &&
              data.filter((x) => {
                return x.isSelected;
              }).length == 0
                ? 'none'
                : ''),
          }
        ]"
        @add="addShow = true"
        @reload="get()"
        @removeFromRedisAll="removeFromRedisAll"
        @scanToQueue="scanToQueue"
      ></cardHead>

          <Form
            method="dialog"
            v-slot="{ errors }"
            class="floating-labels p-1rem border-bottom m-b-0 row"
            ref="form"
          >
                <div class="col">
                  <formGroup
                    :title="'ReservationId'"
                  class="m-b-0"
                  type="number"
                    v-model="model.ReservationId"
                    :errors="errors"
                    @keydown.enter="get"
                  >
                  </formGroup>
                </div>
            <div class="col">
              <searchSelect
                :title="'HotelId'"
                v-model="model.HotelIds"
                :errors="errors"
                :data="
                  $orderByArray(
                    hotels==null?[]:hotels.map((x) => {
                      return {
                        value: x.Id,
                        text: x.Name,
                      };
                    }),
                    'Name',
                    false,
                    false
                  )
                "
              >
              </searchSelect>
            </div>
                <div class="col">
                  <formGroup
                    :title="'Provider'"
                  class="m-b-0"
                    as="select"
                    v-model="model.ProviderId"
                    :errors="errors"
                    @keydown.enter="get"
                    :disabled="providers != null && providers.length == 0"
                  >
                    <template #input>
                      <option :value="null"
                        ></option
                      >
                      <option v-for="item in providers" :value="item.Id" :key="item.ProviderId"
                        >{{item.Name}}</option
                      >
                    </template>
                  </formGroup>
                </div>
                <div class="col">
                  <formGroup
                  :title="'Transfer Status'"
                  class="m-b-0"
                  as="select"
                  v-model="model.TransferStatus"
                  :errors="errors"
                  @keydown.enter="get"
                >
                  <template #input>
                    <option :value="null"
                      ></option
                    >
                    <option :value="1"
                      >Waiting</option
                    >
                    <option :value="2"
                      >Transferred</option
                    >
                    <option :value="3"
                      >Error</option
                    >
                  </template>
                </formGroup>
                </div>
                <div class="col">
                <formGroup
                  :title="'Begin Create Date'"
                  type="date"
                  class="m-b-0"
                  v-model="model.BeginCreateDate"
                  :errors="errors"
                  @keydown.enter="get"
                  :max="$moment(new Date()).format('YYYY-MM-DD')"
                >
                </formGroup>
                </div>
                <div class="col">
                <formGroup
                  :title="'End Create Date'"
                  type="date"
                  class="m-b-0"
                  v-model="model.EndCreateDate"
                  :errors="errors"
                  @keydown.enter="get"
                  :max="$moment(new Date()).format('YYYY-MM-DD')"
                >
                </formGroup></div>
                <div class="col-auto">
                <Btn
                  class="btn-success w100 tcenter m-b-0"
                  @click="get"
                  :process="data == null"
                  >Listele</Btn
                ></div>
          </Form>
      <div class="tables rel">
        <div
          class="myCheckBox abs"
          style="    top: 47px;
    z-index: 5;
    left: 5px;"
        >
          <input
            type="checkbox"
            class="filled-in"
            v-model="selectAll"
            id="chckMassConfirmable"
          /><label for="chckMassConfirmable"></label>
        </div>
        <dataTable
          :name="'confirmedDocuments'"
          ref="agGrid"
          :columnDefs="columnDefs"
          :data="data"
          @removeFromRedis="removeFromRedis($event)"
          @scanErrors="scanErrorsPop = $event.Id"
          @scan="scan"
          @auth="auth"
          @scanQue="scanQue"
          @testConnection="testConnection($event)"
          @cellClicked="clickedCellRezGrid"
          @remove="remove"
          :addContextMenuItem="getContextMenuItems"
          :rowClassRules="{
            // row style function
            warning: (params) => {
              // var numSickDays = params.data;
              return params?.data?.TransferStatus==1;
            },
            danger: (params) => {
              // var numSickDays = params.data;
              return params?.data?.TransferStatus==3;
            },
          }"
        ></dataTable>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
export default {
  name: "CustomerProviders",
  components: {},
  data() {
    return {
      columnDefs: [
        {
          headerName: "",
          width: 35,
          filter: false,
          field: "isSelected",
          sortable: false,
          cellClick: true,
          enableRowGroup: true,
          floatingFilter: false,
          cellRenderer: this.$CheckCellRenderer,
        },
          {
            headerName: "TransferStatus",
            field: "TransferStatus",
            enableRowGroup: true,
            floatingFilter: true,
            filter: "agTextColumnFilter",
            flex: 1,
            minWidth: 140,
            valueFormatter: (params) => {
              if (params.value == 1) {
                return "Waiting";
              } else if (params.value == 2) {
                return "Transferred";
              } else if (params.value == 3) {
                return "Error";
              } 
              return params.value;
            },
          },
          {
            headerName: "ReservationId",
            field: "ReservationId",
            enableRowGroup: true,
            floatingFilter: true,
            filter: "agTextColumnFilter",
            flex: 1,
            minWidth: 140,
          },
          {
            headerName: "AgencyConfirmId",
            field: "AgencyConfirmId",
            enableRowGroup: true,
            floatingFilter: true,
            filter: "agTextColumnFilter",
            flex: 1,
            minWidth: 140,
          },
          {
            headerName: "Voucher",
            field: "Voucher",
            enableRowGroup: true,
            floatingFilter: true,
            filter: "agTextColumnFilter",
            flex: 1,
            minWidth: 140,
          },
          {
            headerName: "HotelName",
            field: "HotelName",
            enableRowGroup: true,
            floatingFilter: true,
            filter: "agTextColumnFilter",
            flex: 1,
            minWidth: 140,
          },
          {
            headerName: "ProviderName",
            field: "ProviderName",
            enableRowGroup: true,
            floatingFilter: true,
            filter: "agTextColumnFilter",
            flex: 1,
            minWidth: 140,
          },
          {
            headerName: "IsDocumentDownloaded",
            field: "IsDocumentDownloaded",
            enableRowGroup: true,
            floatingFilter: false,
            filter: false,
            flex: 1,
            minWidth: 140,
            cellRenderer: this.$CheckCellRenderer,
          },
          {
            headerName: "LastDownloadErrorMessage",
            field: "LastDownloadErrorMessage",
            enableRowGroup: true,
            floatingFilter: true,
            filter: "agTextColumnFilter",
            flex: 1,
            minWidth: 140,
          },
          {
            headerName: "LastDownloadTryDate",
            field: "LastDownloadTryDate",
            enableRowGroup: true,
            floatingFilter: true,
            filter: "agTextColumnFilter",
            flex: 1,
            minWidth: 140,
            cellRenderer: (params) => {
              if (params.value) {
                return moment(new Date(params.value+'Z')).format("DD.MM.YYYY HH:mm:ss");
              }
              return "";
            },
          },
          {
            headerName: "DownloadTryCount",
            field: "DownloadTryCount",
            enableRowGroup: true,
            floatingFilter: true,
            filter: "agTextColumnFilter",
            flex: 1,
            minWidth: 140,
          },
          {
            headerName: "TransferErrorMessage",
            field: "TransferErrorMessage",
            enableRowGroup: true,
            floatingFilter: true,
            filter: "agTextColumnFilter",
            flex: 1,
            minWidth: 140,
          },
          {
            headerName: "TransferDate",
            field: "TransferDate",
            enableRowGroup: true,
            floatingFilter: true,
            filter: "agTextColumnFilter",
            flex: 1,
            minWidth: 140,
            cellRenderer: (params) => {
              if (params.value) {
                return moment(new Date(params.value+'Z')).format("DD.MM.YYYY HH:mm:ss");
              }
              return "";
            },
          },
          {
            headerName: "TransferTryCount",
            field: "TransferTryCount",
            enableRowGroup: true,
            floatingFilter: true,
            filter: "agTextColumnFilter",
            flex: 1,
            minWidth: 140,
          },
          {
            headerName: "FileUrl",
            field: "FileUrl",
            enableRowGroup: true,
            floatingFilter: true,
            filter: "agTextColumnFilter",
            flex: 1,
            minWidth: 140,
            cellRenderer: function(event) {
              return (
                "<a target='_blank' href='" +
                event.value +
                "'>" +
                event.value +
                "</a>"
              );
            },
          }
      ],
      data: null,
      selectAll: false,
      isSelectCount: 0,
      model: {
        ReservationId: null, //int
        CustomerId: null, //int
        ProviderId: null, //int
        TransferStatus: null, //enum
        HotelIds: null, //Array
        BeginCreateDate: null, //DateTime
        EndCreateDate: null, //DateTime
      },
      providers:null,
      hotels:null
    };
  },
  created() {
    this.$appAxiosAdmin.get(`CustomerHotels`).then((response) => {
      this.hotels = this.$orderByArray(response.data, "Name", false, false);
    });
    this.$appAxiosAdmin
      .get(`kolayrez/providers`)
      .then((response) => {
        this.providers = response.data.filter(x=>x.DownloadConfirmed);
      });
    this.get();
  },
  watch: {
    selectAll() {
      if (!this.selectAll) {
        this.data.forEach((element) => {
          if (element.isSelected) {
            element.isSelected = false;
            this.$refs.agGrid.changeRow("ReservationId", element);
          }
        });
        return false;
      }
      let pager = {
        min:
          this.$refs.agGrid.pager.currentPage *
          this.$refs.agGrid.pager.pageSize,
        max:
          (this.$refs.agGrid.pager.currentPage + 1) *
          this.$refs.agGrid.pager.pageSize,
      };
      this.$refs.agGrid.gridApi.forEachNodeAfterFilterAndSort(
        (rowNode, index) => {
          if (index >= pager.min && index < pager.max) {
            this.$refs.agGrid.changeRow("ReservationId", {
              ...rowNode.data,
              isSelected: true,
            });
          }
        }
      );
    },
  },
  methods: {
    get() {
      this.data = null;
      this.selectAll = false;
      this.$appAxiosAdmin
        .post(`ConfirmedDocuments`, {...this.model,
          HotelIds: this.model.HotelIds ? [this.model.HotelIds] : [],
        })
        .then((response) => {
          response.data.forEach((element) => {
            element.isSelected = false;
          });
          this.data = response.data;
        })
              .catch((err) => {
                this.$isError(err);
                this.data=[];
              });
    },
    scanToQueue() {
      let ids = [];
      for (
        let index = 0;
        index < this.$refs.agGrid.gridApi.getDisplayedRowCount();
        index++
      ) {
        if (
          this.$refs.agGrid.gridApi.getDisplayedRowAtIndex(index).data
            .isSelected
        ) {
          ids.push(
            this.$refs.agGrid.gridApi.getDisplayedRowAtIndex(index).data.ReservationId
          );
        }
      }
      if (ids.length > 0) {
        this.$swal({
          icon: "question",
          title: "Warning!",
          text: "Are you sure you want to scans?",
          showCancelButton: true,
          confirmButtonText: "Yes",
          cancelButtonText: "No",
        }).then((question) => {
          if (question.isConfirmed) {
            this.$appAxiosAdmin
              .post(`ConfirmedDocuments/SendToQueue`, ids)
              .then(() => {
                this.$swal({
                  icon: "success",
                  title: "Success",
                  text: "It has been successfully added to the scan queue.",
                  timer: 2000,
                  confirmButtonText: "Okey",
                });
                this.get();
              })
              .catch((err) => {
                this.$isError(err);
              });
          }
        });
      }
    },
    scanQue(item) {
      this.$appAxiosAdmin
        .post(`ConfirmedDocuments/SendToQueue`, [item.ReservationId])
        .then(() => {
          this.$swal({
            icon: "success",
            title: "Success",
            timer: 2000,
            confirmButtonText: "Okey",
          });
                this.get();
        })
        .catch((err) => {
          this.$isError(err);
        });
    },
    clickedCellRezGrid(param) {
      console.log("param.data", param.data);
      if (param.colDef.field == "isSelected") {
        this.$refs.agGrid.changeRow("ReservationId", {
          ...param.data,
          isSelected: !param.data.isSelected,
        });
        this.isSelectCount = this.data.filter((x) => x.isSelected).length;
      } else if (param.colDef.field != "Link") {
        this.detailShow = param.data;
      }
    },
    getContextMenuItems(params) {
      let result = [
        "copy",
        "export",
        {
          name: "Scan Que",
          icon: "<i class='far fa-plus-square'></i>",
          action: () => {
            this.scanQue(params.node.data);
          },
        },
      ];
      return result;
    },
  },
};
</script>
